var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedStartups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15435"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#2622FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.2591 12.9867C34.2171 12.8729 34.1274 12.783 34.0135 12.7412C28.0165 10.5318 23.8415 13.8208 22.3249 15.3374C21.334 16.3283 19.8377 18.3764 18.4075 20.5122C17.462 20.4104 16.1087 20.3672 14.6755 20.658C12.9715 21.0036 11.549 21.7374 10.4475 22.839C10.2504 23.0362 10.3069 23.3793 10.5562 23.5032L15.4623 25.9394L15.912 26.3891L14.6728 26.8022C14.386 26.8978 14.2967 27.2742 14.5108 27.4884L19.5118 32.4894C19.7259 32.7036 20.1024 32.614 20.198 32.3274L20.611 31.0882L21.0608 31.5379L23.497 36.4441C23.6208 36.6934 23.9639 36.7499 24.1612 36.5528C26.6599 34.054 26.6941 30.5027 26.4882 28.5927C28.624 27.1625 30.6719 25.6662 31.6628 24.6753C33.1794 23.1586 36.4684 18.9837 34.2591 12.9867ZM33.5463 13.4539C34.6755 16.6713 34.0951 19.3117 33.1443 21.2211L32.1631 20.2398C32.5685 18.7652 32.194 17.1191 31.0375 15.9626C29.8809 14.8061 28.235 14.4317 26.7603 14.8371L25.7791 13.8559C27.6886 12.9051 30.3289 12.3247 33.5463 13.4539ZM30.4515 21.5887C29.7566 22.2836 28.8442 22.631 27.9315 22.6309C27.019 22.6308 26.1061 22.2834 25.4115 21.5887C24.0219 20.1992 24.0219 17.9382 25.4115 16.5486C26.801 15.1591 29.0619 15.159 30.4515 16.5486C31.8411 17.9381 31.8411 20.1991 30.4515 21.5887ZM15.5442 25.0546L11.4655 23.0294C13.4922 21.3299 16.1337 21.1659 17.8875 21.2967C17.0057 22.6413 16.1776 23.9735 15.5442 25.0546ZM19.6238 31.4292L15.571 27.3764L16.5673 27.0444L19.9558 30.4329L19.6238 31.4292ZM23.9707 35.5345L21.9456 31.4561C23.0266 30.8227 24.3586 29.9947 25.703 29.1129C25.8281 30.8163 25.6798 33.4927 23.9707 35.5345ZM26.8147 27.3679L24.4253 24.9785C24.2635 24.8167 24.0011 24.8167 23.8393 24.9785C23.6775 25.1404 23.6775 25.4027 23.8393 25.5645L26.1164 27.8416C24.4921 28.9326 22.796 29.9992 21.4695 30.7744L16.2258 25.5307C17.0011 24.2042 18.0676 22.5081 19.1587 20.8838L22.4718 24.1969C22.6336 24.3587 22.896 24.3587 23.0578 24.1969C23.2196 24.035 23.2196 23.7727 23.0578 23.6109L19.6324 20.1855C19.8147 19.9196 19.9964 19.6576 20.1766 19.4013L27.599 26.8237C27.3426 27.0038 27.0805 27.1856 26.8147 27.3679ZM28.2835 26.3361L20.6641 18.7167C21.5279 17.5206 22.3255 16.509 22.9109 15.9235C23.3656 15.4688 24.0784 14.842 25.0229 14.2716L25.9167 15.1655C25.5235 15.3682 25.1545 15.6334 24.8253 15.9625C23.1126 17.6753 23.1126 20.4621 24.8253 22.1749C25.6817 23.0312 26.8065 23.4593 27.9314 23.4593C29.0564 23.4593 30.1812 23.0312 31.0375 22.1749C31.3667 21.8457 31.6319 21.4767 31.8345 21.0835L32.7284 21.9774C32.1581 22.9218 31.5313 23.6345 31.0766 24.0892C30.4912 24.6747 29.4797 25.4723 28.2835 26.3361Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.1 16.9C29.9382 16.7382 29.6758 16.7382 29.514 16.9C29.3521 17.0619 29.3521 17.3243 29.514 17.4861C29.9366 17.9088 30.1694 18.4707 30.1694 19.0685C30.1694 19.6663 29.9366 20.2281 29.514 20.6508C29.0913 21.0735 28.5294 21.3063 27.9316 21.3063C27.3339 21.3063 26.772 21.0735 26.3493 20.6508C25.4767 19.7783 25.4767 18.3586 26.3493 17.4862C26.7922 17.0432 27.4064 16.8065 28.0314 16.8329C28.26 16.8442 28.4536 16.6659 28.4638 16.4373C28.4739 16.2086 28.2967 16.015 28.0681 16.005C27.2102 15.9669 26.3701 16.2931 25.7632 16.9001C24.5675 18.0957 24.5675 20.0412 25.7632 21.2369C26.3611 21.8347 27.1462 22.1337 27.9316 22.1336C28.7167 22.1335 29.5022 21.8346 30.0999 21.2369C30.6792 20.6577 30.9982 19.8876 30.9982 19.0685C30.9982 18.2494 30.6792 17.4792 30.1 16.9Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.8694 19.7304C29.2355 19.7304 29.5324 19.4336 29.5324 19.0674C29.5324 18.7012 29.2355 18.4043 28.8694 18.4043C28.5032 18.4043 28.2063 18.7012 28.2063 19.0674C28.2063 19.4336 28.5032 19.7304 28.8694 19.7304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.6462 31.3551C14.2781 29.9871 12.0522 29.9871 10.6842 31.3551C10.5224 31.517 10.5224 31.7793 10.6842 31.9411C10.846 32.1029 11.1084 32.1029 11.2702 31.9411C12.3151 30.8963 14.0152 30.8963 15.0601 31.9411C15.5662 32.4473 15.845 33.1202 15.845 33.836C15.845 34.5518 15.5662 35.2248 15.0601 35.7309C14.2571 36.5339 11.3897 36.9752 9.87321 37.1296C9.95817 36.3117 10.1704 34.6272 10.579 33.3325C10.6479 33.1143 10.5268 32.8815 10.3085 32.8126C10.0903 32.7436 9.85747 32.8648 9.78856 33.083C9.20223 34.941 9.00906 37.45 9.00114 37.5559C8.98245 37.8051 9.19639 38.0183 9.44538 38.0001C9.94522 37.9626 14.366 37.5972 15.6461 36.3171C16.3088 35.6544 16.6738 34.7732 16.6738 33.836C16.6738 32.8989 16.3089 32.0178 15.6462 31.3551Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.0215 31.9806C14.3428 31.302 13.2386 31.3021 12.5601 31.9807C11.9942 32.5465 11.3311 34.8344 11.2038 35.2873C11.118 35.5928 11.409 35.8839 11.7148 35.7982C12.1677 35.671 14.4556 35.0079 15.0214 34.442C15.3502 34.1133 15.5312 33.6762 15.5312 33.2112C15.5312 32.7463 15.3502 32.3094 15.0215 31.9806ZM14.6981 33.2997C14.6781 33.5092 14.5841 33.7072 14.4353 33.856C14.1966 34.0946 13.1587 34.4838 12.2205 34.7814C12.5181 33.8433 12.9071 32.8056 13.146 32.5667C13.4156 32.2971 13.8384 32.2242 14.1828 32.3882C14.5264 32.5518 14.7343 32.9214 14.6981 33.2997Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedStartups);
export default __webpack_public_path__ + "static/media/VerifiedStartups.29e9a390da1472754c24b0e9f6dd9170.svg";
export { ForwardRef as ReactComponent };